<main>
    <!-- <div>
        back
    </div> -->

    <div class="teacher-head flex-wrap gap-2">
        <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
            <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
            <div class="header-text teacher-text">
                User management
            </div>
        </div>
        <div class="d-flex gap-3 align-items-center  gap-2 justify-content-start back-label-title">

            <!-- <div> -->
            <div class="search-container">
                <div class="search-icon">
                    <img src="assets/icons/side-bar/search-normal.svg" alt="search"
                        style="width: 18px; height: 18px;" />
                </div>
                <input type="text" placeholder="Search here..." class="search-input" [(ngModel)]="search"
                    (input)="updateSearch(search)" (keyup.enter)="applyFilter()" autocomplete="off" />
            </div>
            <!-- </div> -->

            <div class="status-dropdown-container"
                *ngIf="userRoles?.add?.addCSQUser || userRoles?.add?.addTeacher || userRoles?.add?.addStudent || userRoles?.add?.addAdmin">
                <div class="status-display" (click)="toggleStatusDropdown($event)">
                    <img src="assets/images/add-icon.svg" alt="plus" class="plus-icon" /> {{'Add'}}
                    <img src="assets/images/Buttons/arrow.svg" class="dropdown-arrow"
                        [class.rotated]="!showStatusDropdown" />
                </div>

                <div class="status-dropdown-menu" [class.show]="showStatusDropdown" (click)="$event.stopPropagation()">
                    <button class="status-option" *ngIf="userRoles?.add?.addCSQUser"
                        (click)="openAddCSQUserDialog('user')" [disabled]="isProcessing">
                        Add CSQ user
                    </button>
                    <button class="status-option" *ngIf="userRoles?.add?.addTeacher" (click)="openAddTeacherDialog()"
                        [disabled]="isProcessing">
                        <span>Add teacher</span>
                    </button>

                    <button class="status-option" *ngIf="userRoles?.add?.addStudent" (click)="openAddStudentDialog()"
                        [disabled]="isProcessing">
                        <span>Add student</span>
                    </button>
                    <button class="status-option" *ngIf="userRoles?.add?.addAdmin"
                        (click)="openAddCSQUserDialog('CSQ Admin')" [disabled]="isProcessing">
                        <span>Add CSQ admin</span>
                    </button>
                    <button class="status-option" *ngIf="userRoles?.add?.addAdmin"
                        (click)="openAddCSQUserDialog('Super Admin')" [disabled]="isProcessing">
                        <span>Add Super admin</span>
                    </button>
                </div>

                <div class="status-backdrop" *ngIf="showStatusDropdown" (click)="closeStatusDropdown()"></div>
            </div>

            <app-export-dropdown
              label="Export"
              *ngIf="userRoles?.export"
              [apiWise]="true"
              [exportApiUrl]="getExportApiUrl()"
              [tableName]="'Users'"
              [currentParams]="getCurrentExportParams()"
              [isSearch]="!!search"
              (export)="onExportComplete($event)"
            ></app-export-dropdown>

        </div>
    </div>
    <div class="user-card">
        <!-- <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-search"> -->
        <!-- <app-input class="form-item" label="Name" placeholder="Enter Your Name" type="text"
                [control]="nameControl"></app-input> -->


        <!-- <app-input class="form-item" label="User Role" placeholder="Select User Role" type="select"
                [control]="userTypeControl" [options]="role">
            </app-input> -->


        <!-- <app-input class="form-item" label="Status" placeholder="Select Status" type="select"
                [control]="statusControl" [options]="status">
            </app-input> -->


        <!-- <app-input class="form-item" label="School" placeholder="Enter School Name" type="text"
                [control]="schoolControl"></app-input> -->

        <!-- <div class="search-container">
                <button *ngIf="isSearchActive" class="clear-button" type="button" (click)="onClear()">Clear</button>

                <button class="search-button" type="submit"
                    [disabled]="!userForm.dirty || !userForm.valid || !hasFilterInput()">
                    Search
                </button>
            </div> -->

        <!-- </form> -->


        <div class="table-card">
            <!-- <div class="d-flex justify-content-end align-items-center pb-3">
                <button class="filter-button">
                    <img src="assets/images/filter-edit.svg" alt="search" class="search-icon" />
                </button>
            </div> -->
            <app-table [columns]="columns" [data]="data" [actionTemplate]="actionButtonsTemplate"
                [loading]="dataLoading" (rowClick)="onView($event)" (statusClick)="onStatusClick($event)"
                tableName="User management"
                [totalItems]="totalRecords"
                [currentPage]="currentPage"
                [pageSize]="pageSize"
                (pageChange)="onPageChange($event)"
                [serverSidePagination]="true"
                [sortableColumns]="sortableColumns"
                [sortColumn]="sortColumn"
                [sortDirection]="sortDirection"
                (sortClick)="onSort($event)">
            </app-table>
        </div>
    </div>

    <ng-template #actionButtons let-row>
        <div style="display: flex; gap: 0.8rem; justify-content: center;">
            <img *ngIf="userRoles?.listItem?.view" class="action-button" (click)="onView(row)"
                src="assets/images/Buttons/view-button.svg" alt="View" />
            <img *ngIf="userRoles?.listItem?.edit" class="action-button" (click)="onEdit(row)"
                src="assets/images/Buttons/edit-button.svg" alt="Edit" />
            <img *ngIf="userRoles?.listItem?.delete" class="action-button" (click)="onDelete(row)"
                src="assets/images/Buttons/delete-button.svg" alt="Delete" />
        </div>
    </ng-template>


    <ng-template #addCSQContent>
        <div class="dialog-content">
            <form [formGroup]="csqForm" class="d-grid gap-14">

                <div class="grid-container">
                    <div class="form-group w-100">
                        <app-input context="Normal" class="form-item" label="First name"
                            placeholder="Enter your first name" type="text" [control]="csqForm.get('firstName')"
                            formControlName="firstName" [control]="csqForm.get('firstName')" [required]="true"
                            [customErrorMessages]="customErrorMessages.firstName">
                        </app-input>
                    </div>

                    <div class="form-group w-100">
                        <app-input context="Normal" class="form-item" label="Last name"
                            placeholder="Enter your last name" type="text" [control]="csqForm.get('lastName')"
                            formControlName="lastName" [control]="csqForm.get('lastName')" [required]="true"
                            [customErrorMessages]="customErrorMessages.lastName">
                        </app-input>
                    </div>
                </div>

                <div class="grid-container">
                    <div class="form-group w-100">
                        <app-input context="Normal" class="form-item" label="Email" placeholder="Enter your email"
                            type="email" formControlName="email" [control]="csqForm.get('email')" [required]="true"
                            [customErrorMessages]="customErrorMessages.email">
                        </app-input>
                    </div>

                    <div class="form-group w-100">
                        <app-input context="Normal" class="form-item" label="Phone number"
                            placeholder="Enter your phone number" type="text" formControlName="mobileNumber"
                            [control]="csqForm.get('mobileNumber')" [required]="true"
                            [customErrorMessages]="customErrorMessages.mobileNumber">
                        </app-input>
                    </div>
                </div>

            </form>
        </div>
    </ng-template>


</main>